import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { createPost } from '@core/actions/classRoom/createPost';
import {
  currentUser,
  currentUserId as getCurrentUserId,
} from '@core/selectors/user';
import { isInstructor } from '@core/selectors/classroom';
import { isAntivirusFileScanEnabled } from '@core/constants/launchDarklyFeatureFlags';
import AulaEditorWithAnalyticsWithoutPlugins from '../../../common/AulaEditor/AulaEditorWithAnalyticsWithoutPlugins';
import AulaEditorWithAnalytics from '../../../common/AulaEditor/AulaEditorWithAnalytics';
import generateEditorConfig from '../../generateEditorConfig';
import ComposePost from '../Shared/ComposePost/ComposePost';

const mapStateToProps = (state, ownProps) => {
  const currentUserId = getCurrentUserId(state);
  const isEducator = isInstructor(state, currentUserId);
  const { feedType, flags } = ownProps;
  const user = currentUser(state);

  return {
    spaceId: state.data.classRooms[state.classRoom.current]
      ? state.data.classRooms[state.classRoom.current].objectId
      : undefined,
    isSavingPost: state.posts.isCreatingPost,
    isChangingClassRoom: state.classRoom.isChangingClassRoom,
    isEducator,
    editorConfig: generateEditorConfig({
      state,
      itemType: feedType,
      itemId: undefined,
      enableAntivirusFileScan: isAntivirusFileScanEnabled(flags),
    }),
    feedType,
    EditorComponent: isEducator
      ? AulaEditorWithAnalytics
      : AulaEditorWithAnalyticsWithoutPlugins,
    author: user
      ? {
          firstName: user.firstName || '',
          lastName: user.lastName || '',
          avatarUrl: user.avatar,
        }
      : undefined,
  };
};

const mapDispatchToProps = (dispatch) => ({
  createPost: (postData) => dispatch(createPost(postData)),
});

const ClassRoomComposePostContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ComposePost);

export default withRouter(withLDConsumer()(ClassRoomComposePostContainer));
